<script setup lang="ts">
import FormAlert from "@/components/FormAlert.vue";

defineProps<{
  show: boolean;
  workflowName?: string;
  // Publish-gate error (invalid BBEL / unbound secret / bad sub-workflow graph) — rendered inline.
  error?: unknown;
  applying?: boolean;
}>();

const emit = defineEmits<{
  confirm: [];
  cancel: [];
  "dismiss-error": [];
}>();
</script>

<template>
  <div
    class="modal fade"
    :class="{ show }"
    :style="{ display: show ? 'block' : 'none' }"
    @click.self="emit('cancel')"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title">Apply changes and run</h2>
          <button type="button" class="btn-close" :disabled="applying" @click="emit('cancel')"></button>
        </div>

        <div class="modal-body">
          <p class="mb-2">
            <strong>{{ workflowName || "This workflow" }}</strong> has unpublished changes. A run always
            uses the applied version, so these changes are applied first, then the workflow runs.
          </p>
          <FormAlert :error="error" @dismiss="emit('dismiss-error')" />
        </div>

        <div class="modal-footer">
          <button class="bb-btn-cancel" :disabled="applying" @click="emit('cancel')">Cancel</button>
          <button class="bb-btn-primary-cta" :disabled="applying" @click="emit('confirm')">
            <span v-if="applying" class="spinner-border spinner-border-sm me-2" role="status"></span>
            <i v-else class="bi bi-play-fill me-1"></i>Apply &amp; Run
          </button>
        </div>
      </div>
    </div>
  </div>
  <div v-if="show" class="modal-backdrop fade show" @click="emit('cancel')"></div>
</template>
